import { render } from "./DoelInverse.vue?vue&type=template&id=5f057c82&scoped=true"
import script from "./DoelInverse.vue?vue&type=script&lang=js"
export * from "./DoelInverse.vue?vue&type=script&lang=js"

import "./DoelInverse.vue?vue&type=style&index=0&id=5f057c82&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f057c82"]])

export default __exports__